import { ConstraintSpec } from '../../../../process/capability-spec/constraints/constraint-spec'

export class ConstraintConf {
  public constraintSpecId: string

  public values: string[] = []

  public spec: ConstraintSpec
}
